<template>
  <div id="MainMenu">
    <el-menu
      mode="horizontal"
        v-if="$store.state.HCRoutes.permissions"
    >
      <el-menu-item
        v-for="(e, i) in MenuList"
        :key="i"
        @click="RouteGo(e.name)"
        :class="setCurrent(e)"
        >{{ e.title }}</el-menu-item
      >
      <!-- 
        :class="$route.meta.setIndex==(i+1)?'is-active':''" -->
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1",
      MenuList: [],
      tab:0
    };
  },
  computed: {
    setCurrent(e){
      return (e) =>{
        const CurrentPath = this.$route.meta.setIndex
        // console.log(CurrentPath)
        const current = e.current === CurrentPath ? "is-active" : ""
        return current
      }
    }
  },
  methods: {
    defaultTab(){
      if(this.$getSession("IndexTab") === null){
        this.tab = 0
      }else{
        this.tab = parseInt(this.$getSession("IndexTab"))
      }
    },
    setTab(i){
      this.tab=i
      this.$setSession("IndexTab",this.tab)
    },
    getRoutes(){
      const permissions = this.$store.state.HCRoutes.permissions
      this.MenuList = permissions
    },
  },
  created(){
    this.defaultTab()
    this.getRoutes()
    // console.log(this.$route)
  }
};
</script>


// WEBPACK FOOTER //
// src/components/MainMenu/index.vue